import { h } from "omi";

import { IconProps } from "@/components";

export function DeleteIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="m17 9-6 6m0-6 6 6M2.72 12.96l4.32 5.76c.352.4693.528.704.75105.8732.19755.15.42127.2618.65972.3299C8.72 20 9.01334 20 9.6 20h7.6c1.6802 0 2.5202 0 3.162-.327a2.999437 2.999437 0 0 0 1.311-1.311C22 17.7202 22 16.8802 22 15.2V8.8c0-1.68016 0-2.52024-.327-3.16197-.2876-.56449-.7465-1.02343-1.311-1.31105C19.7202 4 18.8802 4 17.2 4H9.6c-.58666 0-.88 0-1.14923.07689a2.000043 2.000043 0 0 0-.65972.32986C7.568 4.576 7.392 4.81067 7.04 5.28l-4.32 5.76c-.25819.3443-.38729.5164-.43706.7054a1.000398 1.000398 0 0 0 0 .5092c.04977.189.17887.3611.43706.7054Z"
      />
    </svg>
  );
}
